import { Form, Formik } from "formik";
import { atom, useAtom } from "jotai";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import { formDataAtom } from "../App";
import axios from "axios";
import Progressbar from "../components/Progressbar/Progressbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useRef, useState } from "react";
import Checkbox from "../components/Form/Checkbox";
import BackButton from "../components/Buttons/BackButton";
import ErrorList from "../components/Form/ErrorList";
import { handleSubmitClick } from "../components/Form/FormUtils";
import Spinner from "../components/Spinner/Spinner";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { radiotest_CAR, radiotest_TAXI, radiotest_TICKET } from "./Kitchensink";
import JourneySummary from "../components/Summary/JourneySummary";
import { createJourney } from "../utils/journeyHelpers";
import {mapFormDataToPayload } from "../utils/mapFormDataToPayload"
interface SummaryModel {
    SeatAvailabilityDisclaimer: boolean;
    SelfResponsibility: boolean;
    gdprAccept: boolean;
}
interface Issue {
    id: string;
}

export const issueAtom = atom<Issue>({
    id: "",
});

export default function Summary() {
    const [formData, setFormData] = useAtom(formDataAtom);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const navigate = useNavigate();

    const requiredCheckbox = (errorMessage: string) =>
        Yup.bool().oneOf([true], errorMessage);

    const journeys = [
        createJourney(formData.selectedJourney, "Resa dit", "../vart-vill-ni-resa"),
    ];

    if (formData.selectedReturnJourney && formData.selectedReturnJourney.fromName) {
        journeys.push(createJourney(formData.selectedReturnJourney, "Resa tillbaka", "../valj-aterresa"));
    }

    const TravelContacts = [
        {
            Headline: "Vilka är ni som ska resa?",
            organization: formData.schoolorg || "Ej angivet",
            travelQty: formData.travelQty || "Ej angivet",
            contactPerson: formData.contactperson || "Ej angivet",
            phone: formData.phonenumberschoolorg || "Ej angivet",
            contactEmail: formData.mailadress || "Ej angivet",
            contactPhone: formData.phonenumber || "Ej angivet",
        },
    ];

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, setIssueId] = useAtom(issueAtom);
    const formRef = useRef<HTMLFormElement>(null);

    function GetEditButtonForNavigation(path: string, text?: string) {
        return (
            <button
                type="button"
                className="btn stripped icon-link p-0 justify-self-end change-link pb-3 pt-3 md:pt-0"
                onClick={() => navigate(path)}
            >
                <FontAwesomeIcon
                    className="text-xl mr-2 relative text-r"
                    icon={solid("edit")}
                />
                {text ?? "Gå tillbaka och ändra"}
            </button>
        );
    }

    return (
        <div>
            <Formik<SummaryModel>
                
                onSubmit={(values) => {
                    
                    const payload = mapFormDataToPayload(formData);
                    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

                    setIsFormSubmitted(true);

                    axios
                        .post(
                            `${apiBaseUrl?.replace(/\/$/, '') ?? ''}/GroupTravel/SendApplication`,
                            payload,
                            {
                                headers: {
                                    "referrer-policy": "strict-origin",
                                },
                            }
                        )
                        .then((result) => {
                            setIssueId({ id: result.data });
                            setFormData((prevData) => ({
                                ...prevData,
                                SeatAvailabilityDisclaimer: values.SeatAvailabilityDisclaimer,
                                SelfResponsibility: values.SelfResponsibility,
                                gdprAccept: values.gdprAccept,
                            }));

                            // navigate("/tack-sida", { state: { emailContact } });
                            navigate("/tack-sida");
                        })
                        .catch((error) => {
                            navigate("../ett-fel-intraffade");
                        });
                }}
                initialValues={{
                    SeatAvailabilityDisclaimer: false,
                    SelfResponsibility: false,
                    gdprAccept: false,

                }}
                validateOnChange={false}
                validateOnBlur={false}

                validationSchema={Yup.object().shape({
                    SeatAvailabilityDisclaimer: requiredCheckbox("Ni måste acceptera villkoren för att kunna skicka er anmälan"),
                    SelfResponsibility: requiredCheckbox("Ni måste acceptera villkoren för att kunna skicka er anmälan"),
                    gdprAccept: requiredCheckbox("Du måste godkänna hanteringen av dina personuppgifter."),
                })}

                enableReinitialize
            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-between items-center">
                            <div className="flex justify-center h-15 md:h-auto mb-1">
                                <div
                                    className={`w-full text-left md:hidden ${isFormSubmitted === true ? "hide" : ""
                                        }`}
                                >
                                </div>
                            </div>

                            <div className="xs:w-52 md:w-full max-w-xs">
                                <Progressbar percentage={"100"} />
                            </div>
                        </div>
                        <Form>

                            <Box fullwidth>
                                {isFormSubmitted && <Spinner label="Skickar ..." />}
                                <div
                                    className={`inner-summary summary-box ${isFormSubmitted === true ? "hide" : ""
                                        }`}
                                >
                                    <h2 ref={h2Ref} tabIndex={-1} id="SummaryHeading">
                                        Granska och skicka in anmälan
                                    </h2>

                                    {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                    <p>
                                        Har allt blivit rätt? Kolla alla uppgifter en sista gång innan ni skickar in anmälan om gruppresa.
                                        För att ändra något klickar ni på "Gå tillbaka och ändra".
                                        Då kommer ni till sidan i formuläret där ni kan ändra. Klicka sedan på "Skicka anmälan" i det sista steget.
                                    </p>

                                    <div className="summary-section patient-summary border-b border-grey-200 mb-6 pb-6">
                                        <div className="summary-data-wrapper flex flex-col">

                                            {journeys.map((journey, index) => (
                                                <JourneySummary
                                                    key={index}
                                                    journey={journey}
                                                    editPath={`/edit/${index}`}
                                                    isReturnTravel={journey.Headline.includes("tillbaka")}
                                                />
                                            ))}


                                            {!formData.selectedReturnJourney.fromName ? (
                                                <div className="border-b border-grey-200 border-0 mb-4 pb-4 last:border-none last:mb-0 last:pb-0">
                                                    <h3 className="summary-section-heading h2">Behöver ni en återresa?</h3>

                                                    <p>Om det har blivit ändrade planer så kan vi hjälpa er att lägga till en återresa, er utresa kommer inte att påverkas.</p>

                                                    <Link className="single-link" to="/valj-aterresa" >
                                                        <FontAwesomeIcon icon={solid("plus")} />
                                                        Lägg till en resa
                                                    </Link>
                                                </div>
                                            ) : (
                                                <>
                                                </>
                                            )}


                                            {TravelContacts.map((entry, index) => (

                                                <div key={index} className="border-b border-grey-200 mb-4 pb-4 last:border-none last:mb-0 last:pb-0">

                                                    <h3 className="summary-section-heading h2">{entry.Headline}</h3>
                                                    <div className="mt-2 flex flex-col md:flex-row justify-between md:gap-4">
                                                        <div className="flex flex-col gap-2">
                                                            <div>
                                                                <span className="summary-data-label">Skola/Organisation:</span>
                                                                <span className="summary-data">{entry.organization}</span>
                                                            </div>

                                                            <div>
                                                                <span className="summary-data-label">Antal resenärer:</span>
                                                                <span className="summary-data">{entry.travelQty}</span>
                                                            </div>

                                                            <div>
                                                                <span className="summary-data-label">Kontaktperson:</span>
                                                                <span className="summary-data">{(entry.contactPerson)}</span>
                                                            </div>

                                                            <div>
                                                                <span className="summary-data-label">Telefonnummer:</span>
                                                                <span className="summary-data">{entry.phone}</span>
                                                            </div>

                                                            <div>
                                                                <span className="summary-data-label">Mejladress:</span>
                                                                <span className="summary-data">{entry.contactEmail}</span>
                                                            </div>

                                                            <div className="mt-4">
                                                                <h4 className="mb-2">Hur når vi dig under resan?</h4>
                                                                <span className="summary-data-label">Telefonnummer:</span>
                                                                <span className="summary-data">{entry.contactPhone}</span>
                                                            </div>

                                                        </div>
                                                        <div className="flex flex-col">
                                                            <div className="summary-edit md:mb-6 mt-3 md:mt-0">
                                                                <div className="whitespace-nowrap summary-edit md:mb-0 mt-3 md:mt-0">{GetEditButtonForNavigation("../kontaktuppgifter")}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="summary-acceptance mb-6">
                                        <h2 tabIndex={-1}>
                                            Villkor för resan
                                        </h2>

                                        <div className="mt-6 mb-6 md:mb-8">
                                            <Checkbox name="SeatAvailabilityDisclaimer">
                                                Jag har läst och förstått att Östgötatrafiken inte kan garantera en plats på resan även om jag anmält det i förväg.
                                            </Checkbox>
                                        </div>
                                        <div className="mt-6 mb-6 md:mb-8">
                                            <Checkbox name="SelfResponsibility">
                                                Jag har läst och förstått att jag själv ansvarar för att hålla mig uppdaterad om eventuella ändringar i avgångstid på de resor som vi tänkt göra.
                                            </Checkbox>
                                        </div>
                                        <div className="mt-6 mb-6 md:mb-8">
                                            <Checkbox name="gdprAccept">
                                                Jag godkänner att Östgötatrafiken sparar och hanterar mina
                                                personuppgifter enligt{" "}
                                                <Link
                                                    target="_blank"
                                                    className="red-link underline hover:no-underline"
                                                    to="https://www.ostgotatrafiken.se/info/integritetspolicy-for-ostgotatrafikens-kunder/"
                                                >
                                                    relevant dataskyddslagstiftning.
                                                    <FontAwesomeIcon
                                                        icon={solid("external-link")}
                                                        className="ml-2"
                                                    />
                                                </Link>
                                            </Checkbox>
                                        </div>
                                    </div>
                                </div>

                            </Box>

                            <div
                                className={`flex justify-centery ${isFormSubmitted === true ? "hide" : ""
                                    }`}
                            >
                                <div className="w-full text-left flex items-center">
                                    <BackButton backUrl="/kontaktuppgifter" />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Skicka anmälan
                                    </button>
                                </div>
                            </div>
                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}

function getTestRadioReadable(radiotest: string): string {
    return radiotest === radiotest_TICKET ? "med biljett" :
        radiotest === radiotest_TAXI ? "med taxi" :
            radiotest === radiotest_CAR ? "med bil" :
                "";
}

// function formValidation(data: FormModel): any {
//     let valObj = {
//         paymentwithapp: Yup.bool().test(
//             "form-filled-out",
//             "Det saknas obligatoriska uppgifter under betalning med app.",
//             () => {
//                 return isAppPaymentFilledOut(data);
//             }
//         ),
//         paymentwithtravelcard: Yup.bool().test(
//             "form-filled-out",
//             "Det saknas obligatoriska uppgifter under betalning med reskort.",
//             () => {
//                 return isTravelcardPaymentFilledOut(data);
//             }
//         ),
//     } as any;
//     return valObj;
// }

// function isAppPaymentFilledOut(data: FormModel): boolean {

//     if (data.paymentmethod === WITH_APP) {
//         return (
//             (data.phonenumberapp != "" || data.ticketnumber != "")
//         );
//     }
//     else if (data.paymentmethod === WITH_TRAVELCARD) {
//         return (
//             (data.cardnumber != "")
//         );
//     } else {
//         return(true);
//     }
// }

